import domtoimage from 'dom-to-image';

export const convertDOMToBlobFilePromise = ( domElement ) => new Promise( (resolve, reject) =>{

	domtoimage.toBlob(domElement)
	.then(async function  (blob) {
		//saveAs(blob, 'my-node.png');
		blob.lastModifiedDate = new Date();
		blob.name = "customTemplate";
		const blobfile = new File([blob],"customtemplate.png", {
			type: "image/png",
			lastModified: Date.now()
		});
		resolve( blobfile );
	})
	.catch((error)=>{
		reject("Error in converting"+error);
	});
});
